import React, { useState } from 'react'
import MainLayout from 'layouts/main'
import { useFlagcardContext } from 'app/contexts/flagcard'
import backofficeDefinitionService from 'services/http/backoffice/definition/'

import { CreateTumblrResponse } from './../../../services/http/backoffice/definition/types'
import { IFormValues } from './types'

import Page from '@zera-admin/page'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import { Column, Row, PageHeader } from '@zera-admin/page'
import Button from '@zera-admin/button'
import Checkbox from '@zera-admin/checkbox'
import Input from '@zera-admin/input'
import DateTimePicker from '@zera-admin/datetime-picker'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { RadioGroup } from '@zera-admin/radio'
import Icon from '@zera-admin/icon'
import Form, {
  useForm,
  FormHookSubmitProps,
  FormHeader,
  FormFooter,
  FormSection,
} from '@zera-admin/form'
import { ENVIRONMENT } from 'constants/environment'

const Tumblr = () => {
  const [blackListWord, setBlackListWord] = useState<string>('')
  const [flagcard] = useFlagcardContext()

  const initialValues: CreateTumblrResponse = {
    crawlingType: 'fetch',
    definitionType: 'keyword',
    definitionValue: undefined,
    countryPerception: 40,
    allowedLanguages: undefined,
    allowedDbs: undefined,
    useIncomingDefinition: false,
    environment: ENVIRONMENT,
    definitionBlackLists: undefined,
    periodicFetch: false,
    period: undefined,
    toDate: undefined,
  }
  const handleAddBlackListWord = () => {
    if (blackListWord) {
      form.handleFieldChange('definitionBlackLists', [
        ...(form.values.definitionBlackLists || []),
        blackListWord,
      ])
      setBlackListWord('')
    }
  }

  const handleRemoveBlackListWord = (index: number) => {
    form.handleFieldChange(
      'definitionBlackLists',
      form.values.definitionBlackLists?.filter((_, i) => i !== index)
    )
  }
  const form = useForm<CreateTumblrResponse>({
    initialValues,
    onSubmit: (props) => handlerSubmit(props),
  })

  const handlerSubmit = (props: FormHookSubmitProps<CreateTumblrResponse>) => {
    console.log(form.values)
    if (!props.errors) {
      if (form.values) {
        backofficeDefinitionService
          .createTumblr(form.values)
          .then(() => {
            flagcard.add({
              appearance: 'success',
              title: 'Kayıt işlemi başarılı',
              children:
                'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
            })
            form.handleBatchUpdate(initialValues)
          })
          .catch((error) => {
            console.log(error)
            flagcard.add({
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
      }
    }
  }

  const renderPageContent = () => {
    return (
      <React.Fragment>
        <Form onSubmit={handlerSubmit}>
          <FormHeader
            title="Tumblr Tanımlama Formu"
            description={
              <div style={{ marginBottom: '1.5rem' }}>
                <p>Form üzerinden aşağıdaki genel bilgileri doldurunuz.</p>
                <p style={{ margin: '0', color: '#A73121' }}>
                  Doldurulması zorunlu alanlar (*) işareti ile belirtilmiştir.
                </p>
              </div>
            }
          />
          <FormSection>
            <Row>
              <Column md={{ size: 3 }}>
                <RadioGroup
                  label="*CrawlingType"
                  name="crawlingType"
                  isRequired
                  options={[{ label: 'Fetch', value: 'fetch' }]}
                  value={form.values.crawlingType}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'crawlingType',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column md={{ size: 3 }}>
                <RadioGroup
                  label="*Definition Type"
                  name="definitionType"
                  isRequired
                  options={[
                    { label: 'Keyword', value: 'keyword' },
                    { label: 'Account', value: 'account' },
                  ]}
                  value={form.values.definitionType}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'definitionType',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                <Input
                  label="*Definition Value"
                  name="definitionValue"
                  isRequired
                  placeholder={
                    form.values.definitionType === 'keyword'
                      ? 'Bir kelime giriniz'
                      : 'Bir hesap adı giriniz'
                  }
                  value={form.values.definitionValue}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'definitionValue',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Database Seçimi"
                  name="allowedDbs"
                  description="*Çekilen verilerin işlendikten sonra hangi db 'lere kaydedileceğini belirtir."
                  placeholder="Seçim Yapın"
                  isMultiple
                  options={[{ label: 'Oracle', value: 'oracle' }]}
                  value={form.values.allowedDbs?.map((db) => ({
                    label: db,
                    value: db,
                  }))}
                  onChange={(e) => {
                    const value = e as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'allowedDbs',
                      value.length > 0 ? value.map((db) => db.value) : undefined
                    )
                  }}
                />
              </Column>
            </Row>
            <>
              <Row>
                <Column xs={{ size: 4 }}>
                  <Input
                    name="blackListWord"
                    label="Tanımlama Kara Listesi"
                    placeholder="Bir kara liste kelimesi giriniz"
                    description="Bir kara liste kelimesi giriniz"
                    value={blackListWord}
                    onChange={(props) => {
                      setBlackListWord(props.currentTarget.value)
                    }}
                  />
                </Column>
                <Column xs={{ size: 4 }}>
                  <Button
                    onClick={handleAddBlackListWord}
                    appearance="primary"
                    children="Ekle"
                    style={{ marginTop: '16px' }}
                  />
                </Column>
              </Row>
              {form.values.definitionBlackLists?.map((word, index) => (
                <Row key={index}>
                  <Column xs={{ size: 4 }}>{word}</Column>
                  <Column>
                    <Button
                      onClick={() => handleRemoveBlackListWord(index)}
                      appearance="error"
                      children="Kaldır"
                      style={{ marginTop: '16px' }}
                    />
                  </Column>
                </Row>
              ))}
            </>

            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  label="Bu definitiondan gelen postlar direkt olarak bu definition ile işaretlensin mi işaretlenmesin mi?"
                  name="useIncomingDefinition"
                  isChecked={form.values.useIncomingDefinition}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'useIncomingDefinition',
                      e.currentTarget.checked
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  label="Periyodik olarak çekilsin mi ?"
                  name="periodicFetch"
                  isChecked={form.values.periodicFetch}
                  onChange={(e) => {
                    const value = e.currentTarget.checked
                    form.handleFieldChange('periodicFetch', value)
                  }}
                />
              </Column>
            </Row>
            {form.values.periodicFetch && (
              <Row>
                <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                  <Input
                    label="*Period"
                    name="period"
                    placeholder="Periyot giriniz (0 * * * *)"
                    description="Geçerli bir periyot giriniz"
                    isRequired={form.values.periodicFetch}
                    value={form.values.period}
                    onChange={(e) => {
                      const value = e.currentTarget.value
                      form.handleFieldChange(
                        'period',
                        value !== '' ? value : undefined
                      )
                    }}
                  />
                </Column>
              </Row>
            )}
          </FormSection>
          <FormFooter align="start">
            <Button
              isDisabled={
                (form.values.periodicFetch && !form.values.period) ||
                form.values.definitionValue === ''
              }
              appearance="primary"
              iconBefore={<Icon name="add-item" />}
              children="Tanımlama Oluştur"
              type="submit"
            />
          </FormFooter>
        </Form>
      </React.Fragment>
    )
  }

  return (
    <MainLayout>
      <Page>
        <PageHeader
          breadcrumbs={
            <Breadcrumb>
              <BreadcrumbItem text="Anasayfa" href="/" />
              <BreadcrumbItem text="Tanımlama" href="/definition" />
              <BreadcrumbItem
                text="Tanımlama oluştur"
                href="/definition/create"
              />
              <BreadcrumbItem text="Tumblr" />
            </Breadcrumb>
          }
        />

        {renderPageContent()}
      </Page>
    </MainLayout>
  )
}

export default Tumblr
